export default (t) => [
  {
    text: t('Avatar'),
    value: 'avatar',
    sortable: false,
    fixed: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Full Name'),
    value: 'fullname',
    sortable: true,
    fixed: false,
    togglable: true
  },
  {
    text: t('Telephone'),
    value: 'telephone1',
    sortable: true,
    fixed: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Email'),
    value: 'email',
    sortable: true,
    fixed: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Registered On'),
    value: 'created_at',
    sortable: true,
    fixed: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'state',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
